import { createSelector } from '@reduxjs/toolkit';
import { selectHasVideo } from 'shared/selectors/jsonQuery';

export const selectHasVideoFilter = createSelector(selectHasVideo, value => ({
  label: 'Видео',
  value: Boolean(value),
}));
